import { initializeApp, FirebaseApp } from 'firebase/app';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getAuth, Auth } from 'firebase/auth';

// Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDummyKeyForDevelopment123456",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "attendance-monitoring-dev.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "attendance-monitoring-dev",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "attendance-monitoring-dev.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "123456789012",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:123456789012:web:abcdef1234567890"
};

// Initialize Firebase
let app: FirebaseApp | null = null;
let db: Firestore | null = null;
let auth: Auth | null = null;

try {
  app = initializeApp(firebaseConfig);
  db = getFirestore(app);
  auth = getAuth(app);
  
  if (process.env.NODE_ENV === 'development') {
    console.log('Firebase initialized in development mode');
    // If using dummy keys, add a warning
    if (firebaseConfig.apiKey === "AIzaSyDummyKeyForDevelopment123456") {
      console.warn('Using development Firebase configuration. Set up .env file for proper configuration.');
    }
  }
} catch (error) {
  console.error('Error initializing Firebase:', error);
}

// Helper functions to safely access Firebase instances
export const getDB = (): Firestore => {
  if (!db) {
    throw new Error('Firestore instance not available');
  }
  return db;
};

export const getAuthInstance = (): Auth => {
  if (!auth) {
    throw new Error('Auth instance not available');
  }
  return auth;
};

export default app;